import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Button from "../components/BSL_Button";
import { fetchTimeout } from "../components/Common";
import { updateAreaSpecification } from "../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../redux_store/jobState_Schemas";
import RotateRightIcon from "@material-ui/icons/RotateRight";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { Badge, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        position: "fixed",
        zIndex: "999999",
        bottom: "200px",
        display: "flex",
        flexDirection: "row",
        overflow: "none",
        fontSize: "small",
        background: "#96b7d459",
    },
    header: {
        width: "25%",
        textAlign: "center",
        justifyItems: "center",
    },
    cell: {
        width: "25%",
        textAlign: "center",
        justifyItems: "center",
    },
    button: {
        minWidth: "13px",
        padding: "2px",
    },
});

function syntaxHighlight(json) {
    if (typeof json != "string") {
        json = JSON.stringify(json, undefined, 2);
    }
    json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replaceAll("\\r\\n", "<br>");
    return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        function (match) {
            var cls = "number";
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = "key";
                } else {
                    cls = "string";
                }
            } else if (/true|false/.test(match)) {
                cls = "boolean";
            } else if (/null/.test(match)) {
                cls = "null";
            }
            // let data = match.replaceAll("\r\n", '<br>');
            // console.log(data);
            return '<span class="' + cls + '">' + match + "</span>";
        }
    );
}

export default function Dash(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [intialise, setIntialise] = React.useState(false);
    const [checker, setChecker] = React.useState(0);
    const [diagnosticDataTest, setDiagnosticDataTest] = React.useState(null);
    const [diagnosticDataLocal, setDiagnosticDataLocal] = React.useState(null);
    const [diagnosticDataProd1, setDiagnosticDataProd1] = React.useState(null);
    const [diagnosticDataProd2, setDiagnosticDataProd2] = React.useState(null);
    const [diagnosticDataProd3, setDiagnosticDataProd3] = React.useState(null);

    const [errorInt, setErrorInt] = React.useState(0);

    const user = useSelector((state) => state.app.user);

    React.useEffect(() => {
        if (!intialise && errorInt === 0) {
            // console.log("checking servers");

            fetchTimeout(
                "https://centenarydesignsuite.fielders.com.au:44301/api/IsAlive/ping",
                {
                    method: "GET",
                },
                2000
            )
                .then((response) => response.json())
                .then((json) => {})
                .catch((e) => {
                    setErrorInt(errorInt + 1);
                });

            let api_url_local = "http://localhost:62027/api/IsAlive/ping?detailed=true";
            fetchTimeout(api_url_local, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json);
                    setDiagnosticDataLocal(json);
                    setIntialise(true);
                })
                .catch((e) => {
                    console.log("ERROR", e);
                });

            let api_url_test = "https://test.centenarydesignsuite.fielders.com.au/api/IsAlive/ping?detailed=true";
            fetchTimeout(api_url_test, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json);
                    setDiagnosticDataTest(json);
                    // setBusinessList(json);
                    // setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    console.log("ERROR", e);
                    // setBusinessList([]);
                });

            let api_url_prod1 = "https://centenarydesignsuite.fielders.com.au:44301/api/IsAlive/ping?detailed=true";
            fetchTimeout(api_url_prod1, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json);
                    setDiagnosticDataProd1(json);
                    // setBusinessList(json);
                    // setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    console.log("ERROR", e);
                    setErrorInt(errorInt + 1);
                    // setBusinessList([]);
                });

            let api_url_prod2 = "https://centenarydesignsuite.fielders.com.au:44302/api/IsAlive/ping?detailed=true";
            fetchTimeout(api_url_prod2, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json);
                    setDiagnosticDataProd2(json);
                    // setBusinessList(json);
                    // setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    console.log("ERROR", e);
                    // setBusinessList([]);
                });

            let api_url_prod3 = "https://centenarydesignsuite.fielders.com.au:44303/api/IsAlive/ping?detailed=true";
            fetchTimeout(api_url_prod3, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json);
                    setDiagnosticDataProd3(json);
                    // setBusinessList(json);
                    // setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    console.log("ERROR", e);
                    // setBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        const timer = setTimeout(() => {
            // console.log("slow checker!");
            setIntialise(false);
            setChecker(checker + 1);
        }, 30000);
        return () => clearTimeout(timer);
    }, [checker]);

    React.useEffect(() => {
        if (
            diagnosticDataTest === null ||
            diagnosticDataTest?.status?.[qd_key] !== 4 ||
            diagnosticDataProd1 === null ||
            diagnosticDataProd1?.status?.[qd_key] !== 8 ||
            diagnosticDataProd2 === null ||
            diagnosticDataProd2?.status?.[qd_key] !== 8 ||
            diagnosticDataProd3 === null ||
            diagnosticDataProd3?.status?.[qd_key] !== 8
        ) {
            const timer = setTimeout(() => {
                setIntialise(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [intialise, diagnosticDataTest, diagnosticDataProd1, diagnosticDataProd2, diagnosticDataProd3]);

    const RestartQQUsingHelper = (server) => {
        let api_url =
            "https://test.centenarydesignsuite.fielders.com.au/api/admin/SendHelperCommand?command=RestartAll";
        if (server === "test") {
            setDiagnosticDataTest(null);
        } else if (server === "prod1") {
            setDiagnosticDataProd1(null);
            api_url =
                "https://centenarydesignsuite.fielders.com.au:44301/api/admin/SendHelperCommand?command=RestartAll";
        } else if (server === "prod2") {
            setDiagnosticDataProd2(null);
            api_url =
                "https://centenarydesignsuite.fielders.com.au:44302/api/admin/SendHelperCommand?command=RestartAll";
        } else if (server === "prod3") {
            setDiagnosticDataProd3(null);
            api_url =
                "https://centenarydesignsuite.fielders.com.au:44303/api/admin/SendHelperCommand?command=RestartAll";
        }
        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                console.log(json);
            })
            .catch((e) => {
                console.log("ERROR", e);
            });
    };

    const DownloadLog = (server) => {
        let api_url = "https://test.centenarydesignsuite.fielders.com.au";
        if (server === "local") {
            api_url = "http://localhost:62027";
        } else if (server === "prod1") {
            api_url = "https://centenarydesignsuite.fielders.com.au:44301";
        } else if (server === "prod2") {
            api_url = "https://centenarydesignsuite.fielders.com.au:44302";
        } else if (server === "prod3") {
            api_url = "https://centenarydesignsuite.fielders.com.au:44303";
        }
        api_url += "/api/admin/GetQQSErrorDetailed";

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then(async (response) => {
                if (response.status >= 200 && response.status < 300) {
                    let response_text = await response.text();
                    var element = document.createElement("a");
                    element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(response_text));
                    element.setAttribute("download", server + "_GetQQSErrorDetailed.log");

                    element.style.display = "none";
                    document.body.appendChild(element);

                    element.click();
                }
            })
            .catch((e) => {
                console.log("ERROR", e);
            });
    };

    const green_tick = <CheckCircleIcon style={{ color: "green" }} />;
    const red_cross = <CancelIcon style={{ color: "#b72222" }} />;

    const qqs_key = "QQServer Instances";
    const qd_key = "QikDraw Instances";
    const qh_key = "QQSHelper Instances";

    if (!user?.Role || user?.Role !== 99) {
        return null;
    }
    if (errorInt > 0) return null;

    return (
        <div className={classes.root}>
            <table>
                <tr>
                    <td></td>
                    <td className={classes.header}>LOC</td>
                    <td className={classes.header}>TEST</td>
                    <td className={classes.header}>P1</td>
                    <td className={classes.header}>P2</td>
                    <td className={classes.header}>P3</td>
                </tr>
                <tr>
                    <td>API</td>
                    <td className={classes.cell}>{diagnosticDataLocal?.alive ? green_tick : red_cross}</td>
                    <td className={classes.cell}>{diagnosticDataTest?.alive ? green_tick : red_cross}</td>
                    <td className={classes.cell}>
                        {diagnosticDataProd1?.alive || diagnosticDataProd1 === true ? green_tick : red_cross}
                    </td>
                    <td className={classes.cell}>
                        {diagnosticDataProd2?.alive || diagnosticDataProd2 === true ? green_tick : red_cross}
                    </td>
                    <td className={classes.cell}>
                        {diagnosticDataProd3?.alive || diagnosticDataProd3 === true ? green_tick : red_cross}
                    </td>
                </tr>
                <tr>
                    <td>QQS</td>
                    <td className={classes.cell}>
                        {diagnosticDataLocal?.status?.[qqs_key] ? (
                            <Badge badgeContent={diagnosticDataLocal?.status?.[qqs_key]} color="primary">
                                {green_tick}
                            </Badge>
                        ) : (
                            red_cross
                        )}
                    </td>
                    <td className={classes.cell}>
                        {diagnosticDataTest?.status?.[qqs_key] ? (
                            <Badge badgeContent={diagnosticDataTest?.status?.[qqs_key]} color="primary">
                                {green_tick}
                            </Badge>
                        ) : (
                            red_cross
                        )}
                    </td>
                    <td className={classes.cell}>
                        {diagnosticDataProd1?.status?.[qqs_key] ? (
                            <Badge badgeContent={diagnosticDataProd1?.status?.[qqs_key]} color="primary">
                                {green_tick}
                            </Badge>
                        ) : (
                            red_cross
                        )}
                    </td>
                    <td className={classes.cell}>
                        {diagnosticDataProd2?.status?.[qqs_key] ? (
                            <Badge badgeContent={diagnosticDataProd2?.status?.[qqs_key]} color="primary">
                                {green_tick}
                            </Badge>
                        ) : (
                            red_cross
                        )}
                    </td>
                    <td className={classes.cell}>
                        {diagnosticDataProd3?.status?.[qqs_key] ? (
                            <Badge badgeContent={diagnosticDataProd3?.status?.[qqs_key]} color="primary">
                                {green_tick}
                            </Badge>
                        ) : (
                            red_cross
                        )}
                    </td>
                </tr>
                <tr>
                    <td>QD</td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataLocal?.status?.[qd_key]} color="primary">
                            {diagnosticDataLocal?.status?.[qd_key] >= 4 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataTest?.status?.[qd_key]} color="primary">
                            {diagnosticDataTest?.status?.[qd_key] == 4 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataProd1?.status?.[qd_key]} color="primary">
                            {diagnosticDataProd1?.status?.[qd_key] == 8 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataProd2?.status?.[qd_key]} color="primary">
                            {diagnosticDataProd2?.status?.[qd_key] == 8 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataProd3?.status?.[qd_key]} color="primary">
                            {diagnosticDataProd3?.status?.[qd_key] == 8 ? green_tick : red_cross}
                        </Badge>
                    </td>
                </tr>
                <tr>
                    <td>QQH</td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataLocal?.status?.[qh_key]} color="primary">
                            {diagnosticDataLocal?.status?.[qh_key] == 1 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataTest?.status?.[qh_key]} color="primary">
                            {diagnosticDataTest?.status?.[qh_key] == 1 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataProd1?.status?.[qh_key]} color="primary">
                            {diagnosticDataProd1?.status?.[qh_key] == 1 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataProd2?.status?.[qh_key]} color="primary">
                            {diagnosticDataProd2?.status?.[qh_key] == 1 ? green_tick : red_cross}
                        </Badge>
                    </td>
                    <td className={classes.cell}>
                        <Badge badgeContent={diagnosticDataProd3?.status?.[qh_key]} color="primary">
                            {diagnosticDataProd3?.status?.[qh_key] == 1 ? green_tick : red_cross}
                        </Badge>
                    </td>
                </tr>
                <tr>
                    <td>RESTART</td>
                    <td className={classes.cell}></td>
                    <td className={classes.cell}>
                        <BSL_Button
                            className={classes.button}
                            disabled={!diagnosticDataTest}
                            onClick={() => RestartQQUsingHelper("test")}
                        >
                            {diagnosticDataTest?.status?.[qd_key] > 3 ? (
                                <RotateRightIcon />
                            ) : (
                                <CircularProgress style={{ width: "20px", height: "20px", color: "white" }} />
                            )}
                        </BSL_Button>
                    </td>
                    <td className={classes.cell}>
                        <BSL_Button
                            className={classes.button}
                            disabled={!diagnosticDataProd1}
                            onClick={() => RestartQQUsingHelper("prod1")}
                        >
                            {diagnosticDataProd1?.status?.[qd_key] > 4 ? (
                                <RotateRightIcon />
                            ) : (
                                <CircularProgress style={{ width: "20px", height: "20px", color: "white" }} />
                            )}
                        </BSL_Button>
                    </td>
                    <td className={classes.cell}>
                        <BSL_Button
                            className={classes.button}
                            disabled={!diagnosticDataProd2}
                            onClick={() => RestartQQUsingHelper("prod2")}
                        >
                            {diagnosticDataProd2?.status?.[qd_key] > 4 ? (
                                <RotateRightIcon />
                            ) : (
                                <CircularProgress style={{ width: "20px", height: "20px", color: "white" }} />
                            )}
                        </BSL_Button>
                    </td>
                    <td className={classes.cell}>
                        <BSL_Button
                            className={classes.button}
                            disabled={!diagnosticDataProd3}
                            onClick={() => RestartQQUsingHelper("prod3")}
                        >
                            {diagnosticDataProd3?.status?.[qd_key] > 4 ? (
                                <RotateRightIcon />
                            ) : (
                                <CircularProgress style={{ width: "20px", height: "20px", color: "white" }} />
                            )}
                        </BSL_Button>
                    </td>
                </tr>
                <tr>
                    <td>Logs</td>
                    <td className={classes.cell}>
                        <div onClick={() => DownloadLog("local")}>QQS</div>
                    </td>
                    <td className={classes.cell}>
                        <div onClick={() => DownloadLog("test")}>QQS</div>
                    </td>
                    <td className={classes.cell}></td>
                    <td className={classes.cell}></td>
                    <td className={classes.cell}>
                        <div onClick={() => DownloadLog("prod3")}>QQS</div>
                    </td>
                </tr>
            </table>
        </div>
    );
}
